<template>
  <div>
    <div class="recomendList" v-if="recomedList.length > 0">
      <div class="topInfo">
        <div class="title">
          <div>
            <img src="../assets/images/images/topTitle.png" alt />
            <div class="recomendWord">最新入驻</div>
          </div>
        </div>
        <div class="goInsert" @click="goMyShop">{{ shenq }}</div>
      </div>
      <div
        style="overflow-x: scroll; overflow-y: hidden"
        id="parent"
        @touchstart="touchList"
      >
        <div class="itemList">
          <div
            class="item"
            v-for="(item, index) in recomedList"
            :key="index"
            @click="goshopDetail(item.shop.id)"
          >
            <div style="text-align: left; padding-left: 5px">
              {{ item.shop.name }}
            </div>
            <div class="itemBottom">
              <div>
                <img :src="item.shop.small_logo_url" alt="" />
              </div>
              <div
                style="
                  flex-grow: 1;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="aaa"
                  style="
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  "
                >
                  <span style="color: #662d91">{{ item.shop.view_num }}</span
                  >条动态
                </div>
                <div class="GoDetail">查看</div>
              </div>
            </div>
          </div>
          <div
            class="item"
            style="display: flex; align-items: center"
            @click="goMoreShop"
          >
            <div>更多企业</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let me;
let time;
import { Dialog } from "vant";
import { getData } from "../Interface/http.js";
export default {
  name: "recomendShopInClass",
  data() {
    return {
      shenq: "申请入驻>",
      recomedList: [], //推荐列表
      userInfoData: [], //用户信息
      loginStatus: false,
    };
  },
  props: ['vipStatus','leftDay'],
  methods: {
    //跳转更多企业
    goMoreShop() {
      me.$router.push({
        name: "shopList",
      });
    },
    touchList() {
      clearInterval(time);
    },
    getUserInfo() {
      getData("/user/info", {
        token:
          localStorage.getItem("token") != ""
            ? localStorage.getItem("token")
            : "123456",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取商家推荐列表信息
    getRecomedList() {
      getData("/recommend-shops", {
        num: 10,
      }).then((res) => {
        me.recomedList = res.data;
      });
    },
    login() {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "about");
        window.location.href = res.data.redirect_url;
      });
    },
    //跳转店铺详情
    goshopDetail(id) {
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: id,
        },
      });
    },
    //跳转到续费页面
    goXFPage() {
      this.$router.push({
        name: "continuePay",
        query: {
          id: me.userInfoData.shop_id,
        },
      });
    },
    //判断跳转我的店铺还是申请店铺
    goMyShop() {
      let me = this;
      if (!me.loginStatus) {
        //如果未登录
        //如果未登录
        me.login();
        return;
      }
      if (me.leftDay.type == "over") {
        Dialog.confirm({
          message: "你之前的门店已过期，是否续费",
        })
          .then(() => {
            me.goXFPage();
          })
          .catch(() => {
            console.log("取消");
          });
        return;
      }
      console.log(me.vipStatus);
      if (me.userInfoData.shop_id == 0 || !me.userInfoData.shop_status) {
        if (me.vipStatus && me.vipStatus.type == "on") {
            this.$toast("后台正在审核，请勿重新申请！");
            return;
        }
        this.$router.push({
          name: "addShop",
        });
      } else {
        Dialog.confirm({
          message: "您已开通过店铺，是否进入自己的店铺管理中心",
        })
          .then(() => {
            me.$router.push({
              name: "mangerMyShop",
              query: {
                shop_id: me.userInfoData.shop_id,
              },
            });
          })
          .catch(() => {
            console.log("取消");
          });
      }
    },
  },
  mounted() {
    me = this;
    me.getRecomedList();
    me.getUserInfo();
    me.$nextTick(() => {
      var div2 = document.getElementById("parent");
      if(div2) {
        time = setInterval(function () {
          div2.scrollLeft++;
        }, 17);
      }
      
    });
    window.addEventListener("scroll", function () {
      clearInterval(time);
    });
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = false;
    } else {
      this.loginStatus = true;
    }
  },
};
</script>
<style scoped>
.recomendList {
  width: 344px;
  margin: 10px auto;
  border-radius: 5px;
  background-color: #fff;
  padding-bottom: 10px;
}
.title {
  width: 62px;
  height: 23px;
  margin-left: 6px;
}
.title > div:nth-child(1) {
  position: relative;
}
.recomendWord {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 12px;
  top: 0;
}
.topInfo {
  display: flex;
}
.topInfo > div:nth-child(2) {
  flex-grow: 1;
  text-align: right;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.goInsert {
  font-size: 13px;
  color: #662d91;
}
.itemList {
  width: fit-content;
  height: 75px;
  display: flex;
  margin-top: 10px;
}
.itemList > div {
  width: 106px;
  height: 100%;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 0 4px;
}
.item > div:nth-child(1) {
  width: calc(100% - 5px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  font-weight: bold;
}
.itemBottom {
  display: flex;
  margin: 6px 0px 6px 6px;
}
.itemBottom > div:nth-child(1) img {
  width: 45px;
  height: 45px;
}
.itemBottom > div:nth-child(2) {
  height: 45px;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.GoDetail {
  width: 40px;
  font-size: 12px;
  font-weight: bold;
  color: #662d91;
  border: 1px solid #662d91;
  border-radius: 5px;
  margin-top: 5px;
}
.aaa {
  width: 48px;
}
</style>